import { Select as n, selectClasses as r, outlinedInputClasses as i, MenuItem as d } from "@mui/material";
import { ReactComponent as l } from "./china-flag.svg.mjs";
import { ReactComponent as c } from "./spain-flag.svg.mjs";
import { ReactComponent as s } from "./uk-flag.svg.mjs";
import { ArrowDropDownRounded as p } from "@mui/icons-material";
import { css as u, styled as t } from "./styled2.mjs";
const g = u`
	width: 100%;
`, a = t(p)`
	color: ${({ theme: o, $background: e }) => e === "dark" ? o.palette.common.white : o.palette.action.active};
`, S = t(n)`
	box-sizing: border-box;
	min-width: 101px;
	border-radius: ${({ theme: o }) => o.tokens.radius[8]};
	padding-inline: ${({ theme: o }) => o.spacing(0.5)};

	${({ $fullWidth: o }) => o && g};

	color: ${({ $background: o, theme: e }) => o === "dark" ? e.palette.common.lightGrey : e.palette.text.primary};
	background-color: ${({ $background: o, theme: e }) => o === "dark" ? e.palette.grey[900] : e.palette.background.level1};
	.${r.select} {
		padding: ${({ theme: o }) => o.spacing(0.5)};
	}
	&.${r.disabled} {
		${a} {
			color: ${({ theme: o }) => o.palette.background.level4};
		}
	}

	&:hover:not(.${r.disabled}):not(.Mui-focused) {
		background-color: ${({ theme: o }) => o.palette.action.hover};
		color: ${({ theme: o }) => o.palette.text.primary};
		border-color: ${({ theme: o }) => o.palette.action.hover};
		.${i.notchedOutline} {
			border-color: transparent;
			background-color: ${({ theme: o }) => o.palette.action.hover};
		}

		${a} {
			color: ${({ theme: o }) => o.palette.action.active};
		}
	}
`, x = t(l)`
	border-radius: ${({ theme: o }) => o.tokens.radius[4]};
`, f = t(c)`
	border-radius: ${({ theme: o }) => o.tokens.radius[4]};
`, C = t(s)`
	border-radius: ${({ theme: o }) => o.tokens.radius[4]};
`, F = t(d)`
	padding: 2px;
	&.Mui-selected {
		border-radius: ${({ theme: o }) => o.tokens.radius[8]};
	}
`;
export {
  a as ArrowIcon,
  x as ChinaFlagRounded,
  F as LanguageSelectOption,
  S as Select,
  f as SpainFlagRounded,
  C as UkFlagRounded
};
//# sourceMappingURL=styles16.mjs.map
